import { RtfUtilService, XcHelpService } from '@gspwidget/util';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { WidgetDevkitService } from '@gspwidget/widget-devkit';

export const DASHBOARD_API = 'DashboardApi'

/**
 * 此包挂在 window 上，所以任何地方都可以通过 window 直接调用，
 * 其好处是编译期无依赖、不用考虑循环依赖问题；
 * 所以将此文件放在现在依赖链里较高处的 common 里。
 * 扩展的原生 JS 可直接调用，不得已时元部件等也能调。
 */
@Injectable(
  { providedIn: 'root' }
)
export class DashboardApi {
  constructor (
    public messageSvc: NzMessageService,
    public rtfUtilSvc: RtfUtilService,
    public nzModal: NzModalService,
    public widgetDevkit: WidgetDevkitService,
    public http: HttpClient,
    public help2: XcHelpService,
  ) {
    window[DASHBOARD_API] = this
  }
}
